import styled from '@emotion/styled';
import { Box, Typography } from '@mui/material';
import { DataGrid, GridValidRowModel } from '@mui/x-data-grid';
import { useWatch } from 'react-hook-form';
import { useImpactsOnStakeholdersForm } from '../../ImpactsOnStakeholdersFormProvider';
import { StakeholderGroupFormValues } from '../../ImpactsOnStakeholdersFormProvider/types';
import { sortStakeholderGroups } from '../utils';
import {
  getStakeholderAnalysisColumn,
  STAKEHOLDER_ANALYSIS_VISIBILITY,
} from './StakeholderAnalysisColumn';

const mappingStakeholderGroupsDataTable = (
  stakeholderGroups: StakeholderGroupFormValues[]
) => {
  let data: GridValidRowModel[] = [];
  stakeholderGroups?.forEach((group, index) => {
    data = [
      ...data,
      {
        id: `GROUP_HEADER_${index + 1}`,
        columnType: 'GROUP_HEADER',
        stakeholderType: group.stakeholderType,
      },
      {
        ...group,
        id: group.id ? `DETAILS_${group.id}` : `NEW_${index + 1}`,
        columnType: 'GROUP_DETAILS',
      },
    ];
    return null;
  });
  return data;
};

const StylesDataGrid = styled(DataGrid)({
  '[data-id*="DETAIL"] > .MuiDataGrid-cell, [data-id*="NEW"] > .MuiDataGrid-cell':
    {
      borderTop: 'none',
    },
});

const StakeholderAnalysisTable = () => {
  const stakeholderGroups =
    useWatch({
      name: 'stakeholderAnalysis.stakeholderGroups',
    }) || ([] as StakeholderGroupFormValues[]);

  const {
    formState: { errors },
  } = useImpactsOnStakeholdersForm();

  const sortedGroups = sortStakeholderGroups(stakeholderGroups);
  const mapStakeholderGroups = mappingStakeholderGroupsDataTable(sortedGroups);

  return (
    <Box mt={2}>
      <StylesDataGrid
        rows={mapStakeholderGroups ?? []}
        columns={getStakeholderAnalysisColumn(stakeholderGroups)}
        getRowHeight={() => 'auto'}
        disableColumnSorting
        initialState={{
          columns: {
            columnVisibilityModel: STAKEHOLDER_ANALYSIS_VISIBILITY,
          },
        }}
      />
      {errors.stakeholderAnalysis?.stakeholderGroups && (
        <Typography variant="caption" color="error">
          {errors.stakeholderAnalysis.stakeholderGroups.message}
        </Typography>
      )}
      {Array.isArray(errors.stakeholderAnalysis?.stakeholderGroups) &&
        errors.stakeholderAnalysis.stakeholderGroups.some(
          (groupError) =>
            groupError.expectationDescriptionEn?.message ||
            groupError.otherCommunicationActivities?.length > 0 ||
            groupError.otherStakeholders?.length > 0
        ) && (
          <Typography variant="caption" color="error">
            กรุณากรอกข้อมูลให้ครบทุกช่อง
          </Typography>
        )}
    </Box>
  );
};

export default StakeholderAnalysisTable;
